import React from 'react';
import { Route } from 'react-router-dom';
import AuthResetPassword from '../modules/author/AuthorForgetPass';
import ReviewerResetPassword from '../modules/reviewer/ReviewerForgetPass';
import HostResetPassword from '../modules/host/HostForgetPass';

const ForgetPass = (
  <>
      <Route path="/Author/resetpassword" element={<AuthResetPassword />} />
      <Route path="/Reviewer/resetpassword" element={<ReviewerResetPassword />} />
      <Route path="/Host/resetpassword" element={<HostResetPassword />} />

    {/* <Route element={<ProtectedRoute requiredRole="reviewer" />}>
      <Route path="/reviewer" element={<ReviewerLayout />}>
        <Route path="dashboard" element={<ReviewerDashboard />} />
        <Route path="review-submissions" element={<ReviewSubmissions />} />
        <Route path="review-comments" element={<ReviewerViewComments />} />
        <Route path="review-all-papers" element={<ReviewerAllPaper />} />
      </Route>
      <Route path="review/:submissionID" element={<ReviewerReview />} />
    </Route> */}
  </>
);

export default ForgetPass;
